import { ThemeUICSSObject } from 'theme-ui';
import { focusOutline, responsive, spacing } from '../../util';
import { transitions } from './transitions';
import menu from './menu';
import scrollbars from './scrollbars';

export const root: ThemeUICSSObject = {
  ...menu,
  ...scrollbars,

  height: '100%',
  '*': {
    fontFamily: 'body',
    fontWeight: 'body',

    code: {
      fontFamily: 'monospace',
    },

    '&:focus': focusOutline,
  },

  body: {
    // minHeight: '100vh',
  },

  '.requiredFilter__Border': {
    borderLeftStyle: 'solid',
    borderLeftWidth: '4px',
    borderLeftColor: 'palette.error.main',
  },

  h1: {
    fontSize: responsive({ 0: 26, 3: 32 }),
  },
  h2: {
    fontSize: responsive({ 0: 22, 3: 28 }),
  },
  h3: {
    fontSize: responsive({ 0: 19, 3: 25 }),
  },
  h4: {
    fontSize: responsive({ 0: 18, 3: 22 }),
  },
  h5: {
    fontSize: responsive({ 0: 18, 3: 22 }),
  },
  h6: {
    fontSize: responsive({ 0: 17, 3: 17 }),
  },

  'h1,h2,h3,h4,h5,h6': {
    letterSpacing: 'heading',
    lineHeight: 'heading',
    variant: 'text.title',
  },
  '*:not(h1, h2, h3, h4, h5, h6, code)': {
    fontFamily: 'body',
    fontSize: 16,
    fontWeight: 'body',
    letterSpacing: 'body',
    lineHeight: 'body',
  },
  a: {
    textDecoration: 'underline',
  },
  'textarea,a': {
    transition: 'color 200ms ease-out',
    ':focus': {
      ...focusOutline,
    },
    ':focus-visible': {
      ...focusOutline,
    },
  },
  '*:focus': focusOutline,
  ul: {
    listStyle: 'none',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },

  abbr: {
    '&.required': {
      textDecoration: 'none',
      border: 'none',
      mx: 1,
      alignSelf: 'baseline',
      fontWeight: 'bold',
      color: 'danger',
    },
  },
  table: {
    borderCollapse: 'separate',
    borderSpacing: 0,
  },

  '& label': {
    display: 'flex',

    '& > span': {
      mb: spacing(1),
      fontWeight: 'bold',
    },

    '&.required': {
      position: 'relative',
      '&::before': {
        color: 'danger',
        position: 'absolute',
        content: '"*"',
        top: 0,
        left: '-10px',
      },

      '*:invalid': {
        borderColor: 'danger',
      },
    },
  },

  '.bold': {
    fontWeight: 'bold',
  },
  '.light': {
    fontWeight: 'light',
  },

  '.Left': {
    textAlign: 'left !important' as unknown as 'left',
  },
  '.Center': {
    textAlign: 'center !important' as unknown as 'left',
  },
  '.Right': {
    textAlign: 'right !important' as unknown as 'left',
  },
  '.Justify': {
    textAlign: 'justify !important' as unknown as 'left',
  },

  '.Bottom': {
    verticalAlign: 'bottom !important',
  },

  '.Middle': {
    verticalAlign: 'middle !important',
  },

  '.Top': {
    verticalAlign: 'top !important',
  },

  '.hidden': {
    display: 'none',
  },

  '.field__withError': {
    '& input, & textarea, & checkbox, & button[role="checkbox"]': {
      borderLeftStyle: 'solid',
      borderLeftWidth: '4px',
      borderLeftColor: 'danger',
    },
  },

  '.field__touched': {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'touchedBorderColor',
  },

  '.noPadding': {
    padding: 0,
  },

  'input[type="radio"] ~ svg': {
    background: 'transparent !important',
  },

  '.windowModal__active': {
    zIndex: 'tooltip',
  },

  ...transitions,
};
